module.exports = __webpack_public_path__ + "img/BRYANSK.43112ba8.png";